export default __webpack_public_path__ + "static/media/scorecard-variations.91713e52.png";